import { useMutation } from "react-query"
import api from "../client"
import { queryClient, queryKeys } from "../query"
import { UpdateOrderCalculationPaylod, UpdateOrderCalculationResponseData } from "../types/order"

const patchData = async (uuid: string | undefined, payload: UpdateOrderCalculationPaylod) => {
    const { data } = await api.patch<UpdateOrderCalculationResponseData>(
        `/orders/${uuid}`,
        payload
    )

    queryClient.invalidateQueries(queryKeys.ORDER(uuid))
    queryClient.invalidateQueries(queryKeys.ORDER_SUMMARY(uuid), { refetchInactive: true })
    queryClient.invalidateQueries(["orders"], { refetchInactive: true })

    return data
}

export const useUpdateCalculation = (uuid: string | undefined) => {
    return useMutation((payload: UpdateOrderCalculationPaylod) => {
        return patchData(uuid, payload)
    })
}
